import { Boxes, Layers3, Factory, Construction, Building2 } from "lucide-react";

export const DISCIPLINE_ICONS = { Boxes, Layers3, Factory, Construction, Building2 };

export const disciplineIcon = (d) => DISCIPLINE_ICONS[d.icon] || Boxes;
